function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
import Axios from 'axios-observable';
import { InjectableServices } from '../enums';
import { authStorage } from '../local-storage';
import { WindowedObservable } from '../windowed-observable';
import { BaseConfigService } from './base-config.service';
var axiosPerfTracking = Axios.create({});
var DefaultPerformanceData = {
    url: '',
    startTime: '',
    httpVerb: 'POST',
    instanceUiId: '',
    requestSource: 'Client Connections'
};
export var PerformanceTrackingService = /*#__PURE__*/ function(BaseConfigService) {
    "use strict";
    _inherits(PerformanceTrackingService, BaseConfigService);
    function PerformanceTrackingService() {
        _class_call_check(this, PerformanceTrackingService);
        var _this;
        _this = _call_super(this, PerformanceTrackingService, arguments), _define_property(_this, "getRequestPerfTracking", function(config) {
            if (config.url && config.method) {
                // eslint-disable-next-line no-param-reassign
                config.metadataPerfTracking = _object_spread_props(_object_spread({}, config.metadataPerfTracking), {
                    url: config.url,
                    startTime: new Date().toISOString(),
                    instanceUiId: '',
                    httpVerb: config.method.toUpperCase(),
                    requestSource: 'Client Connections'
                });
                return config.metadataPerfTracking;
            }
            return null;
        }), _define_property(_this, "sendPerfTracking", function(param) {
            var response = param.response, storeFboData = param.storeFboData, isError = param.isError;
            if (response.config.metadataPerfTracking) {
                var _authStoredData_user;
                var authStoredData = authStorage.get();
                var _authStoredData_supportUserId;
                response.config.metadataPerfTracking = _object_spread_props(_object_spread({}, response.config.metadataPerfTracking), {
                    endTime: new Date().toISOString(),
                    duration: Date.now() - Date.parse(response.config.metadataPerfTracking.startTime),
                    httpStatusCode: response.status,
                    portalUserId: authStoredData === null || authStoredData === void 0 ? void 0 : (_authStoredData_user = authStoredData.user) === null || _authStoredData_user === void 0 ? void 0 : _authStoredData_user.id,
                    userProfileId: storeFboData === null || storeFboData === void 0 ? void 0 : storeFboData.profileId,
                    exception: isError ? JSON.stringify(response === null || response === void 0 ? void 0 : response.data) : undefined,
                    portalImpersonatorUserId: (_authStoredData_supportUserId = authStoredData === null || authStoredData === void 0 ? void 0 : authStoredData.supportUserId) !== null && _authStoredData_supportUserId !== void 0 ? _authStoredData_supportUserId : undefined
                });
                _this.doSendPerfTracking(response.config.metadataPerfTracking);
            }
        });
        return _this;
    }
    _create_class(PerformanceTrackingService, [
        {
            key: "doSendPerfTracking",
            value: function doSendPerfTracking(perfTrackingData) {
                var _this = this;
                var perfTrackingUrl = "".concat(this.environment.FBO_PERFORMANCE_URL, "/performance/savePageLoaderApi");
                axiosPerfTracking.post(perfTrackingUrl, perfTrackingData).subscribe({
                    error: function(error) {
                        var _this_rollbar;
                        (_this_rollbar = _this.rollbar) === null || _this_rollbar === void 0 ? void 0 : _this_rollbar.error(error);
                    }
                });
            }
        },
        {
            key: "sendDirectPerformanceTracking",
            value: function sendDirectPerformanceTracking(data) {
                var _authStoredData_user;
                var authStoredData = authStorage.get();
                this.doSendPerfTracking(_object_spread(_object_spread_props(_object_spread({}, DefaultPerformanceData), {
                    startTime: new Date().toISOString(),
                    endTime: new Date().toISOString(),
                    portalUserId: authStoredData === null || authStoredData === void 0 ? void 0 : (_authStoredData_user = authStoredData.user) === null || _authStoredData_user === void 0 ? void 0 : _authStoredData_user.id,
                    duration: 1,
                    httpStatusCode: 200
                }), data));
            }
        }
    ], [
        {
            key: "getOrCreate",
            value: function getOrCreate() {
                var observable = new WindowedObservable(InjectableServices.PerformanceTrackingService);
                var state = observable.getLastEvent();
                if (state) {
                    return state;
                }
                var instance = new PerformanceTrackingService();
                observable.publish(instance);
                return instance;
            }
        }
    ]);
    return PerformanceTrackingService;
}(BaseConfigService);
